import { render, staticRenderFns } from "./Present.vue?vue&type=template&id=506b2c34&"
import script from "./Present.vue?vue&type=script&lang=js&"
export * from "./Present.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports